import { render, staticRenderFns } from "./addContactDialog.vue?vue&type=template&id=2fb97b1e"
import script from "./addContactDialog.vue?vue&type=script&lang=js"
export * from "./addContactDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports